<template>
  <div
    class="my-stat-wrapper tw-grid tw-grid-cols-[max-content,1fr,1fr] tw-items-center tw-gap-y-[8px] tw-p-[16px]"
  >
    <div class="tw-me-[10px] tw-text-[16px] tw-text-[var(--my-white-soft)]">
      {{ $t("donor_dashboard.my_contacts_stat_expected_donations", "Expected Donations") }}
    </div>
    <div class="tw-flex tw-justify-between tw-items-center">
      <status-badge :status="STATUS_KEYS.NEW_LEADS" />
      <span class="tw-flex tw-justify-center tw-w-[3cap] tw-text=[16px] tw-text-[--my-white]">{{
        statisticsStatuses[STATUS_KEYS.NEW_LEADS]
      }}</span>
    </div>
    <div class="tw-flex tw-justify-between tw-items-center">
      <status-badge :status="STATUS_KEYS.IN_PROCESS" />
      <span class="tw-flex tw-justify-center tw-w-[3cap] tw-text=[16px] tw-text-[--my-white]">{{
        statisticsStatuses[STATUS_KEYS.IN_PROCESS]
      }}</span>
    </div>
    <div class="tw-me-[10px] tw-text-[var(--my-white-soft2)] tw-text-[25px] tw-font-black">
      {{ expectedDonationsCurrency }}
    </div>
    <div class="tw-flex tw-justify-between tw-items-center">
      <status-badge :status="STATUS_KEYS.NOT_RELEVANT" />
      <span class="tw-flex tw-justify-center tw-w-[3cap] tw-text=[16px] tw-text-[--my-white]">{{
        statisticsStatuses[STATUS_KEYS.NOT_RELEVANT]
      }}</span>
    </div>
    <div class="tw-flex tw-justify-between tw-items-center">
      <status-badge :status="STATUS_KEYS.DONATED" />
      <span class="tw-flex tw-justify-center tw-w-[3cap] tw-text=[16px] tw-text-[--my-white]">{{
        statisticsStatuses[STATUS_KEYS.DONATED]
      }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.my-stat-wrapper {
  @media (max-width: 412px) {
    grid-template-columns: min-content 1fr 1fr;
  }
}
</style>

<script>
import { mapState } from "vuex";
import { STATUS_KEYS } from "@/views/my-contacts/constants";
import statusBadge from "@/views/my-contacts/ui/my-status-badge.vue";

export default {
  data() {
    return {
      STATUS_KEYS,
    };
  },

  computed: {
    ...mapState({
      statisticsStatuses: (state) => state.donorMyContacts.statisticsStatuses,
      campaignCurrency: (state) => state.donorMyContacts.campaignCurrency,
      expectedDonations: (state) => state.donorMyContacts.expectedDonations,
    }),

    expectedDonationsCurrency() {
      if (!this.campaignCurrency) {
        return "";
      }

      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: this.campaignCurrency,
      }).format(this.expectedDonations);
    },
  },

  components: {
    statusBadge,
  },
};
</script>
